import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <span className="font-display text-3xl font-extrabold text-white">MASHIN<span className="brand-accent">IYA</span></span>
          <p className="mt-1 text-xs uppercase tracking-widest text-slate-500">Admin Panel</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-white p-8 shadow-2xl">
          <div className="mb-6 flex items-center gap-2 text-slate-900">
            <Lock size={18} className="brand-accent" />
            <h1 className="font-display text-xl font-bold">Admin Login</h1>
          </div>
          {error && <div data-testid="login-error" className="mb-4 rounded-lg bg-red-50 px-4 py-2.5 text-sm text-red-600">{error}</div>}
          <div className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@example.com" required />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button data-testid="login-submit" type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-full bg-brand py-3 font-bold text-white disabled:opacity-60">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} LOGIN
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
